// promise_conflicts.shopify_order_id holds a GID — recordConflict is called with
// order.gid — while print_jobs.shopify_order_id holds the numeric legacy id. The
// two tables genuinely differ, so the card has to parse the number out to build an
// admin link. Anchored so a Product or DraftOrder GID cannot yield an id that
// links to the wrong resource.
const ORDER_GID = /^gid:\/\/shopify\/Order\/(\d+)$/;

export function orderIdFromGid(gid: string): string | null {
  return ORDER_GID.exec(gid)?.[1] ?? null;
}

function plural(n: number, word: string): string {
  return `${n} ${word}${n === 1 ? "" : "s"}`;
}

export function describeConflictScope(group: {
  order_count: number;
  worst_gap_days: number;
  breach_count: number;
}): string {
  const parts = [
    plural(group.order_count, "order"),
    `worst gap ${plural(group.worst_gap_days, "day")}`,
  ];
  if (group.breach_count > 0) {
    parts.push(`${group.breach_count} already past their deadline`);
  }
  return parts.join(" · ");
}
